<template>
  <v-container fluid>
    <div class="text-h6 white--text d-md-none" style="margin-top: 10px;">Extrato Financeiro</div>
    <div class="text-h6 black--text d-none d-md-block" style="margin-top: 10px;">Extrato Financeiro</div>
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Histórico</th>
            <th class="text-left text-right">Valor</th>
            <th class="text-left text-right">Pago</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in socio.extrato" :key="item.name" :class="{ 'red lighten-5': item.at == 'V', 'green lighten-5': item.s == 'T' }">
            <td class="text-caption">{{ item.nc }}<br />#{{ item.c }} - Venc: {{ item.d }}</td>
            <td class="text-caption text-right">{{ item.v | fmtNumber }}</td>
            <td class="text-caption text-right">{{ item.vp | fmtNumber }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['socio'])
  }
}
</script>
